<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" /> 


    <div v-if="modoDefinirEquipamento">        
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item">
                    <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
                </div>  
                <button class="btn-confirm" @click="setDigitacao">Iniciar</button>
                <button @click="cancelForm">Retornar</button>
            </div>
        </div>
    </div>


    <div v-if="!modoDefinirEquipamento">
        <div class="form-edit-page row row-space">
            <div class="form-item">
                <label class="label-caption">Equipamento/Veículo</label>
                <div class="field-label">{{ equipamentoSelecionado?.nmequipamento }}</div>
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption">Placa</label>
                <div class="field-label field-label-center">{{ equipamentoSelecionado?.placa }}</div>
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Modelo</label>
                <div class="field-label field-label-center">{{ equipamentoSelecionado?.modelo }}</div>
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Setor</label>
                <div class="field-label field-label-center">{{ equipamentoSelecionado?.nmequipamentosetor }}</div>
            </div>
        </div>


        <div class="form-edit-page row-space">
            <div class="row-start row-space">
                <div class="form-item-data">
                    <label class="label-caption">Data Referência</label>
                    <input type="date" v-model="edDtDespesa" />
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">KM/Horas</label>
                    <input v-model="edKmHoras" v-decimal type="text" class="input-right" />
                </div>

                <div class="form-item-char30">
                    <DespesaGrupoSelect v-model:grupoSelecionado="grupoSelecionado" />
                </div>


                <div class="form-item">
                    <FornecedorFrame v-model:objSelecionado="fornecedorSelecionado"/>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edDocNumero" v-number maxlength="11" />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data Emissão</label>
                    <input type="date" v-model="edDocDtEmissao" />
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">Quantidade</label>
                    <input v-model="edQtd" v-decimal type="text" class="input-right" />
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">Valor</label>
                    <input v-model="edVlDespesa" v-decimal type="text" class="input-right" />
                </div>
            </div>

            <div class="row-start row-space">
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="edComplemento" maxlength="100" v-uppercase />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Licitação</label>
                    <input type="text" v-model="edLicitacao" maxlength="100" v-uppercase />
                </div>
            </div>            

            <div class="row-end">
                <button class="btn-confirm" @click="gravarDespesa">Gravar</button>
                <button type="cancel" @click="cancelForm">Encerrar</button>
            </div>
        </div>
    </div>

    <div v-if="lsDespesas.length>0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Nro NF</th>
                    <th>Tipo Despesa</th>
                    <th>Fornecedor</th>
                    <th>Km/Horas</th>
                    <th>Valor</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDespesas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtdespesa) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.docnro) }}</td>
                    <td class="col-width-char40">{{ obj.nmdespesagrupo }}</td>
                    <td>{{ obj.nmfornecedor }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.kmhoras) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.vldespesa) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import DespesaGrupoSelect from '@/selects/DespesaGrupoSelect.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';


const emit=defineEmits(['close', 'salvo']);


const edComplemento = ref(null);
const edDtDespesa = ref(null);
const edDocNumero = ref(null);
const edDocDtEmissao = ref(null);
const edKmHoras = ref(null);
const edLicitacao = ref(null);
const edQtd = ref(null);
const edVlDespesa = ref(null);
const msgAlerta = ref(false);
const idInicial = ref(0);
const isLoading = ref(false);
const lsDespesas = ref([]);
const modoDefinirEquipamento = ref(true);
const equipamentoSelecionado = ref(null);
const fornecedorSelecionado = ref(null);
const grupoSelecionado = ref(null);


function cancelForm() {emit('close')}


async function gravarDespesa() {
    try {
        msgAlerta.value = gravarDespesaValidacao();
        if (msgAlerta.value) return;
        
        isLoading.value=true;
        const despesa = {
            id: 0,
            idmunicipio: globalStore.idmunicipio,
            iddespesagrupo: grupoSelecionado.value,
            idequipamento: equipamentoSelecionado.value.id,
            idfornecedor: fornecedorSelecionado.value.id,
            dtdespesa: edDtDespesa.value,
            docnro: Funcoes.integerFromString(edDocNumero.value),
            docdtemissao: edDocDtEmissao.value,
            complemento: edComplemento.value,
            licitacao: edLicitacao.value,            
            kmhoras: Funcoes.decimalFromString(edKmHoras.value),
            qtd: Funcoes.decimalFromString(edQtd.value),
            vldespesa: Funcoes.decimalFromString(edVlDespesa.value),
            idlogin: globalStore.idlogin};



        const response = await Api.genericPut('/cad/despesa', despesa);
        if (response.bolok===1){
            if (idInicial.value == 0) idInicial.value = response.id;
            if (idInicial.value > 0){
                const req = await Api.genericPost('/dados/despesas', {
                    idmunicipio: globalStore.idmunicipio,
                    idequipamento: equipamentoSelecionado.value.id,
                    id: idInicial.value,
                    idlogin: globalStore.idlogin});
                lsDespesas.value = req;
            }
            limparCampos();
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function gravarDespesaValidacao(){
    let r = Validar.id(equipamentoSelecionado.value, 'Equipamento');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(grupoSelecionado.value, 'Grupo');
    if (!r.ok) return r.msg;
    r = Validar.id(fornecedorSelecionado.value, 'Fornecedor');
    if (!r.ok) return r.msg;
    r = Validar.data(edDtDespesa.value, -180, 'Data da Despesa');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(Funcoes.decimalFromString(edQtd.value), 'Quantidade');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(Funcoes.decimalFromString(edVlDespesa.value), 'Valor da Despesa');
    if (!r.ok) return r.msg;
    return null;
}

function limparCampos(){
    edQtd.value=null;
    edVlDespesa.value=null;
}

function setDigitacao(){
    if (equipamentoSelecionado.value){
        msgAlerta.value=null;
        modoDefinirEquipamento.value=false;
    }else{
        msgAlerta.value='ATENÇÃO: Informe o equipamento';
    }
}
</script>